import React from "react";
import APoolList from "../../../../form/operationlist/PoolList";

export default class PoolList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const propsTop = this.props;
        const {props, state, parent} = propsTop;
        const {hidden, labels, pool, operationitems} = props;
        return props.values[props.componentConfig.idfield] && <APoolList
            ref={(list) => this.list = list}
            loading={props.isLoading}
            className={"p-small-table"}
            data={props.values}
            saveChanges={props.setFieldValue}
            source={{
                ...pool
            }}
            onSourceItemUpdate={propsTop.onSourceItemUpdate || parent.onSourceItemUpdate}
            onTransferItems={parent.onTransferItems}
            onTargetItemUpdate={parent.onTargetItemUpdate}
            control={propsTop.control}
            target={{
                ...operationitems,
                ...(!!props.actions ? {selection: {}} : {})
            }}
            {...props.getProps("items")}
        />
    }
}